import React from "react";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Box,
    Container,
    Divider,
    useTheme
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FaInfoCircle } from "react-icons/fa";
import { ReactComponent as CircleAlertIcon } from "assets/PwC_Funct_Icons_CircleAlert_Fill_Black_RGB.svg"
import {ReactComponent as ChevronDownIcon} from "assets/PwC_Funct_Icons_ChevronDown_Outline_Black_RGB.svg"
import { height, width } from "@mui/system";

const FAQAccordion = ({ faqDataGrouped }) => {
    const theme = useTheme();
    let count = 0;
    return (
        <>
            {
                faqDataGrouped.map((categoryItem, idx) => (
                    <Box key={idx} mb={4}>
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 600,
                                mb: 0,
                                pb: 0,
                                color: `${theme?.customSettings?.themeColor}`,
                                display: 'flex',
                                alignItems: 'center', 
                                gap: '8px' 
                            }}
                        >
                            {/* <FaInfoCircle size={15} /> {categoryItem.category} */}
                            <CircleAlertIcon style={{ width: "26px", height: "26px", fill: theme?.customSettings?.themeColor }} />
                            {categoryItem.category}
                        </Typography>

                        <Divider sx={{ mb: 2 }} />

                        {categoryItem.questions.map((qa, qIdx) => {
                            count += 1;
                            return (
                                <Accordion key={qIdx} disableGutters>
                                    <AccordionSummary
                                    // expandIcon={<ExpandMoreIcon />}
                                        expandIcon={<ChevronDownIcon style={{width:'16px', height:"16px", }} />}
                                        sx={{
                                            backgroundColor: "background.paper",
                                            "& .MuiAccordionSummary-content": {
                                                fontWeight: 500,
                                                fontSize: "16px"
                                            }
                                        }}
                                    >
                                        <Typography
                                            component="span"
                                            sx={{
                                                fontWeight: 500,
                                                lineHeight: "24px",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "6px",
                                            }}
                                        >

                                            {`${count}). ${qa?.q}`}
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails
                                        sx={{
                                            backgroundColor: "#f9f9f9",
                                            borderTop: "1px solid #ddd"
                                        }}
                                    >
                                        <Typography variant="body1" sx={{ lineHeight: 1.6 }}>
                                            {qa.a}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            )
                        }

                        )}
                    </Box>
                ))
            }
        </>
    );

};

export default FAQAccordion;
